import Stack from '@/design_system/Stack';

import { ActionsTable } from './ActionsTable';
import { PackActionsTable } from './PackActionsTable';

export const Actions = () => {
  return (
    <Stack gap="40px" padding="0 0 24px 0">
      <ActionsTable />
      <PackActionsTable />
    </Stack>
  );
};
